<script>
import {
  layoutComputed
} from "@/state/helpers";
import AuthHelper from "@/helpers/auth-helper";

export default {
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      userPermissions: [], // Stocker les permissions de l'utilisateur
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {};
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    this.loadUserPermissions();
    this.initActiveMenu();
    if (this.rmenu == 'vertical' && this.layoutType == 'twocolumn') {
      document.documentElement.setAttribute("data-layout", "vertical");
    }
    document.getElementById('overlay').addEventListener('click', () => {
      document.body.classList.remove('vertical-sidebar-enable');
    });

    window.addEventListener("resize", () => {
      if (this.layoutType == 'twocolumn') {
        var windowSize = document.documentElement.clientWidth;
        if (windowSize < 767) {
          document.documentElement.setAttribute("data-layout", "vertical");
          this.rmenu = 'vertical';
          localStorage.setItem('rmenu', 'vertical');
        } else {
          document.documentElement.setAttribute("data-layout", "vertical");
          this.rmenu = 'twocolumn';
          localStorage.setItem('rmenu', 'twocolumn');
          setTimeout(() => {
            this.initActiveMenu();
          }, 50);

        }
      }
    });
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");

      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                siblingCollapse.classList.remove("show");
                siblingCollapse.parentElement.firstChild.setAttribute("aria-expanded", "false");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2) {
                item.firstElementChild.setAttribute("aria-expanded", "false");
                item.firstElementChild.classList.remove("active");
              }
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                item1.classList.remove("show");
                item1.parentElement.firstChild.setAttribute("aria-expanded", "false");
                item1.parentElement.firstChild.classList.remove("active");
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.classList.remove("show");
            childCollapseInstance.parentElement.firstChild.setAttribute("aria-expanded", "false");
          });
        });
      });
    }
  },

  methods: {
    // Charger les permissions de l'utilisateur
    loadUserPermissions() {
      const permissions = AuthHelper.getPermissions();
      try {
        this.userPermissions = permissions ? JSON.parse(permissions) : [];
      } catch (error) {
        console.error("Erreur lors du parsing des permissions:", error);
        this.userPermissions = [];
      }
    },

    // Vérifier si l'utilisateur a une permission spécifique
    hasPermission(permission) {
      if (!permission) return true;
      return this.userPermissions.includes(permission);
    },

    // Vérifier si l'utilisateur a au moins une des permissions
    hasAnyPermission(permissions) {
      if (!permissions || permissions.length === 0) return true;
      return permissions.some(permission => this.userPermissions.includes(permission));
    },

    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
      }
    },

    initActiveMenu() {
      const pathName = window.location.pathname;
      const ul = document.getElementById("navbar-nav");
      if (ul) {
        const items = Array.from(ul.querySelectorAll("a.nav-link"));
        let activeItems = items.filter((x) => x.classList.contains("active"));
        this.removeActivation(activeItems);
        let matchingMenuItem = items.find((x) => {
          return x.getAttribute("href") === pathName;
        });
        if (matchingMenuItem) {
          this.activateParentDropdown(matchingMenuItem);
        } else {
          var id = pathName.replace("/", "");
          if (id) document.body.classList.add("twocolumn-panel");
          this.activateIconSidebarActive(pathName);
        }
      }
    },
    removeActivation(items) {
      items.forEach((item) => {
        if (item.classList.contains("menu-link")) {
          if (!item.classList.contains("active")) {
            item.setAttribute("aria-expanded", false);
          }
          item.nextElementSibling.classList.remove("show");
        }
        if (item.classList.contains("nav-link")) {
          if (item.nextElementSibling) {
            item?.nextElementSibling?.classList?.remove("show");
          }
          item.setAttribute("aria-expanded", false);
        }
        item.classList.remove("active");
      });
    },

    activateParentDropdown(item) {
      // navbar-nav menu add active
      item.classList.add("active");
      let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
      if (parentCollapseDiv) {
        // to set aria expand true remaining
        parentCollapseDiv.classList.add("show");
        parentCollapseDiv.parentElement.children[0].classList.add("active");
        parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
        if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
          if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling) {
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling.parentElement.closest(".collapse.menu-dropdown")) {
              const grandparent = parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown").previousElementSibling.parentElement.closest(".collapse.menu-dropdown");
              this.activateIconSidebarActive("#" + grandparent.getAttribute("id"));
              grandparent.classList.add("show");
            }
          }
          this.activateIconSidebarActive("#" + parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")
            .getAttribute("id"));

          parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
          if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
            parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
          return false;
        }
        this.activateIconSidebarActive("#" + parentCollapseDiv.getAttribute("id"));
        return false;
      }
      return false;
    },
    activateIconSidebarActive(id) {
      var menu = document.querySelector(
        "#two-column-menu .simplebar-content-wrapper a[href='" +
        id +
        "'].nav-icon"
      );
      if (menu !== null) {
        menu.classList.add("active");
      }
    },
  },
};
</script>

<template>
  <BContainer fluid>
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'vertical' || layoutType === 'semibox'">
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li class="menu-title">
          <span data-key="t-menu"> {{ $t("t-menu") }}</span>
        </li>

        <!-- Drive - Visible pour tous les utilisateurs connectés -->
        <li class="nav-item">
          <router-link to="/drive" class="nav-link menu-link">
            <i class="ri-drive-line"></i>
            <span data-key="t-my-drive"> {{ $t("t-my-drive") }}</span>
          </router-link>
        </li>

        <!-- Tableaux de bord -->
        <li class="nav-item" v-if="hasAnyPermission(['report:read', 'report:generate', 'report:write'])">
          <BLink class="nav-link menu-link" href="#sidebarDashboards" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarDashboards">
            <i class="ri-dashboard-2-line"></i>
            <span data-key="t-dashboards"> {{ $t("t-dashboards") }}</span>
          </BLink>
          <div class="collapse menu-dropdown" id="sidebarDashboards">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item">
                <router-link to="/" class="nav-link" data-key="t-projects">
                  {{ $t("t-projects") }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/activity-dashboard" class="nav-link" data-key="t-activity">
                  {{ $t("t-activity") }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/app-dashboard" class="nav-link" data-key="t-app">
                  {{ $t("t-app") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Tickets -->
        <li class="nav-item" v-if="hasAnyPermission(['ticket:read', 'ticket:write', 'ticket:admin', 'ticket:user', 'ticket:categories'])">
          <router-link to="/ticket" class="nav-link menu-link">
            <i class="ri-ticket-line"></i>
            <span data-key="t-tickets"> {{ $t("t-tickets") }}</span>
          </router-link>
        </li>

        <!-- Publications -->
        <li class="nav-item" v-if="hasAnyPermission(['post:read', 'post:write', 'post:publish', 'post:comment'])">
          <router-link to="/posts" class="nav-link menu-link">
            <i class="ri-article-line"></i>
            <span data-key="t-posts"> {{ $t("t-posts") }}</span>
          </router-link>
        </li>

        <!-- Tâches -->
        <li class="nav-item" v-if="hasAnyPermission(['task:read', 'task:write', 'task:change-status'])">
          <router-link to="/tasks" class="nav-link menu-link">
            <i class="ri-task-line"></i>
            <span data-key="t-tasks"> {{ $t("t-tasks") }}</span>
          </router-link>
        </li>

        <!-- Réunions -->
        <li class="nav-item" v-if="hasAnyPermission(['meeting:read', 'meeting:write', 'meeting:participant'])">
          <router-link to="/meetings" class="nav-link menu-link">
            <i class="ri-calendar-event-line"></i>
            <span data-key="t-meetings"> {{ $t("t-meetings") }}</span>
          </router-link>
        </li>

        <!-- Rapports -->
        <li class="nav-item" v-if="hasAnyPermission(['report:read', 'report:generate', 'report:write'])">
          <router-link to="/report" class="nav-link menu-link">
            <i class="ri-file-chart-line"></i>
            <span data-key="t-report"> {{ $t("t-report") }}</span>
          </router-link>
        </li>

        <!-- Procédures -->
        <li class="nav-item" v-if="hasAnyPermission(['workflows', 'workflow:instance', 'workflow:task:change-status'])">
          <router-link to="/workflows" class="nav-link menu-link">
            <i class="ri-node-tree"></i>
            <span data-key="t-workflow"> {{ $t("t-workflows") }}</span>
          </router-link>
        </li>

        <!-- Gestion de Personnes -->
        <li class="nav-item" v-if="hasAnyPermission(['person:read', 'person:write', 'user:read', 'user:write'])">
          <BLink class="nav-link menu-link" href="#sidebarPeople" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarPeople">
            <i class="ri-team-line"></i>
            <span data-key="t-people"> {{ $t("t-people") }}</span>
          </BLink>
          <div class="collapse menu-dropdown" id="sidebarPeople">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="hasPermission('person:read')">
                <router-link to="/person" class="nav-link" data-key="t-person">
                  {{ $t("t-person") }}
                </router-link>
              </li>

              <li class="nav-item" v-if="hasAnyPermission(['user:read', 'user:write'])">
                <router-link to="/user-management" class="nav-link custom-abc" data-key="t-users">
                  {{ $t("t-users") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Ressources humaines -->
        <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write', 'configuration:hr', 'parameter:hr'])">
          <BLink class="nav-link menu-link" href="#sidebarHR" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarHR">
            <i class="ri-user-settings-line"></i>
            <span data-key="t-hr"> {{ $t("t-hr") }}</span>
          </BLink>
          <div class="collapse menu-dropdown" id="sidebarHR">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/grades/" class="nav-link" data-key="t-grades">
                  {{ $t("t-grades") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/echelons" class="nav-link" data-key="t-echelons">
                  {{ $t("t-echelons") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/hierarchies" class="nav-link" data-key="t-hierarchies">
                  {{ $t("t-hierarchies") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/diplomas" class="nav-link" data-key="t-diplomas">
                  {{ $t("t-diplomas") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/professions" class="nav-link" data-key="t-professions">
                  {{ $t("t-professions") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/jobCategories" class="nav-link" data-key="t-jobCategories">
                  {{ $t("t-jobCategories") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/employee" class="nav-link" data-key="t-employee">
                  {{ $t("t-employee") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/pays/" class="nav-link" data-key="t-pays">
                  {{ $t("t-pays") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/status" class="nav-link" data-key="t-status">
                  {{ $t("t-status") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/jobs" class="nav-link" data-key="t-jobs">
                  {{ $t("t-jobs") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/missions" class="nav-link" data-key="t-missions">
                  {{ $t("t-missions") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('configuration:hr')">
                <router-link to="/formations" class="nav-link" data-key="t-formations">
                  {{ $t("t-formations") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/holidays" class="nav-link" data-key="t-holidays">
                  {{ $t("t-holidays") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/leaves" class="nav-link" data-key="t-leaves">
                  {{ $t("t-leaves") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/sanctions" class="nav-link" data-key="t-sanctions">
                  {{ $t("t-sanctions") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/inactivities" class="nav-link" data-key="t-inactivities">
                  {{ $t("t-inactivities") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/departures" class="nav-link" data-key="t-departures">
                  {{ $t("t-departures") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['employee:read', 'employee:write'])">
                <router-link to="/denunciations" class="nav-link" data-key="t-denunciations">
                  {{ $t("t-denunciations") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('knowledges')">
                <router-link to="/knowledge" class="nav-link custom-abc" data-key="t-knowledge">
                  {{ $t("t-knowledge") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Organisations et Structures -->
        <li class="nav-item" v-if="hasAnyPermission(['institution:read', 'institution:write', 'structure:read', 'structure:write', 'partners'])">
          <BLink class="nav-link menu-link" href="#sidebarOrganization" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarOrganization">
            <i class="ri-building-line"></i>
            <span data-key="t-organization"> {{ $t("t-organization") }}</span>
          </BLink>
          <div class="collapse menu-dropdown" id="sidebarOrganization">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="hasAnyPermission(['institution:read', 'institution:write'])">
                <router-link to="/institution" class="nav-link" data-key="t-institution">
                  {{ $t("t-institution") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('institution:types')">
                <router-link to="/institution-type" class="nav-link" data-key="t-institutionsType">
                  {{ $t("t-institutionsType") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['structure:read', 'structure:write'])">
                <router-link to="/structures" class="nav-link" data-key="t-structures">
                  {{ $t("t-structures") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('partners')">
                <router-link to="/partners" class="nav-link custom-abc" data-key="t-partners">
                  {{ $t("t-partners") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('groups')">
                <router-link to="/group" class="nav-link custom-abc" data-key="t-groups">
                  {{ $t("t-groups") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Gestion des Documents -->
        <li class="nav-item" v-if="hasAnyPermission(['document:read', 'document:write', 'folder:read', 'folder:write', 'keywords', 'file:types', 'templates'])">
          <BLink class="nav-link menu-link" href="#sidebarDocuments" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarDocuments">
            <i class="ri-file-text-line"></i>
            <span data-key="t-documents"> {{ $t("t-documents") }}</span>
          </BLink>
          <div class="collapse menu-dropdown" id="sidebarDocuments">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="hasPermission('document:categories')">
                <router-link to="/category-document" class="nav-link" data-key="t-categoryDocuments">
                  {{ $t("t-categoryDocuments") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('keywords')">
                <router-link to="/keyword" class="nav-link" data-key="t-keywords">
                  {{ $t("t-keywords") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('file:types')">
                <router-link to="/files" class="nav-link" data-key="t-files">
                  {{ $t("t-files") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('report:types')">
                <router-link to="/reports-type" class="nav-link" data-key="t-report-type">
                  {{ $t("t-report-type") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('templates')">
                <router-link to="/template-types/" class="nav-link" data-key="t-templateTypes">
                  {{ $t("t-templateTypes") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('templates')">
                <router-link to="/template-bloc/" class="nav-link" data-key="t-templateBloc">
                  {{ $t("t-templateBloc") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('templates')">
                <router-link to="/template/" class="nav-link" data-key="t-template">
                  {{ $t("t-template") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Configuration Système -->
        <li class="nav-item" v-if="hasAnyPermission(['permissions', 'role:read', 'role:write', 'attributes', 'parameter:user', 'parameter:notification', 'event:types'])">
          <BLink class="nav-link menu-link" href="#sidebarSettings" data-bs-toggle="collapse" role="button"
            aria-expanded="false" aria-controls="sidebarSettings">
            <i class="ri-settings-line"></i>
            <span data-key="t-settings"> {{ $t("t-config") }}</span>
          </BLink>
          <div class="collapse menu-dropdown" id="sidebarSettings">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-if="hasPermission('permissions')">
                <router-link to="/permissions" class="nav-link" data-key="t-permissions">
                  {{ $t("t-permissions") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasAnyPermission(['role:read', 'role:write'])">
                <router-link to="/roles" class="nav-link" data-key="t-roles">
                  {{ $t("t-roles") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('attributes')">
                <router-link to="/attributes" class="nav-link" data-key="t-attributes">
                  {{ $t("t-attributes") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('product:categories')">
                <router-link to="/products" class="nav-link" data-key="t-products">
                  {{ $t("t-products") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('parameter:hr')">
                <router-link to="/pays/" class="nav-link" data-key="t-pays">
                  {{ $t("t-pays") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('parameter:document')">
                <router-link to="/movement-type" class="nav-link" data-key="t-movementType">
                  {{ $t("t-movementType") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('event:types')">
                <router-link to="/events" class="nav-link" data-key="t-events">
                  {{ $t("t-events") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('ticket:categories')">
                <router-link to="/category-ticket" class="nav-link" data-key="t-Categorie-ticket">
                  {{ $t("t-Categorie-ticket") }}
                </router-link>
              </li>
              <li class="nav-item" v-if="hasPermission('support:types')">
                <router-link to="/support-type" class="nav-link custom-abc" data-key="t-supportTypes">
                  {{ $t("t-supportTypes") }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <!-- Paramètres -->
        <li class="nav-item" v-if="hasAnyPermission(['parameter:user', 'parameter:notification', 'parameter:document', 'parameter:hr', 'parameter:meeting', 'parameter:post', 'parameter:ticket', 'parameter:workflow'])">
          <router-link to="/parameters" class="nav-link menu-link">
            <i class="ri-settings-5-fill"></i>
            <span data-key="t-parameters"> {{ $t("t-parameters") }}</span>
          </router-link>
        </li>

      </ul>
    </template>
  </BContainer>
</template>